import { FEATURES } from '@constants/Text'

export const canOperateBackOffice = ({ user = {}, access = {} } = {}) => {
  return !!(user.IS_INTERNAL || access[FEATURES.BACK_OFFICE_SELF_SERVICE])
}

export const canShowBackOfficeRoute = ({ user = {}, access = {} } = {}) => {
  return canOperateBackOffice({ user, access }) && !!access[FEATURES.BACK_OFFICE]
}

export const getResponsibleUsersOptions = ({
  user,
  internalUsers,
  professionals,
} = {}) => {
  if (user && user.IS_INTERNAL) {
    return Array.isArray(internalUsers) ? [...internalUsers] : []
  }
  if (Array.isArray(professionals)) {
    return professionals.map((p) => ({
      id: p.id_profissional || p.id,
      nome: p.nome || '',
    }))
  }
  return []
}
